import Button from "./Button";
import Card from "./Card";

export default function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className = "",
}) {
  return (
    <Card className={`text-center py-12 ${className}`}>
      {Icon && <Icon className="mx-auto h-12 w-12 text-text opacity-40 mb-4" />}
      {title && <h3 className="text-lg font-medium text-text mb-2">{title}</h3>}
      {description && (
        <p className="text-text opacity-60 text-sm mb-6 max-w-md mx-auto">
          {description}
        </p>
      )}
      {action && (
        <div className="mt-6">
          {action.to ? (
            <Button
              as="link"
              to={action.to}
              variant={action.variant || "primary"}
            >
              {action.label}
            </Button>
          ) : (
            <Button
              onClick={action.onClick}
              variant={action.variant || "primary"}
            >
              {action.label}
            </Button>
          )}
        </div>
      )}
    </Card>
  );
}
